import getLang from 'I18n/utils/getLang';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useLocation } from 'quartz-routing/react-router';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { useGates } from '../../hooks/useGates';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';
import { Paths } from '../../constants/paths';
import { DATA_TYPE_MAP } from '../utils/searchMappers';
import { LISTINGS_PER_PAGE } from './useSearchResultsQuery';
const CROSS_SEARCH_TIMEOUT_MS = 10000;
function buildProductTypeFilter(productTypes) {
  const filtersByField = {
    PRODUCT_TYPE: [{
      values: productTypes,
      clause: 'OR',
      negation: false,
      __typename: DATA_TYPE_MAP.STRING
    }]
  };
  return {
    filterGroups: [{
      filtersByField,
      clause: 'AND',
      negation: false
    }],
    clause: 'AND',
    negation: false
  };
}

/**
 * Fetches the result count for the "other side" of the search
 * (solutions partners when on products, or apps/agents when on solutions partners).
 * Only active when tabularSearch is OFF.
 */
export function useCrossSearchCount() {
  var _result$data;
  const gates = useGates();
  const location = useLocation();
  const searchParams = useSearchParams();
  const search = searchParams.get('search');
  const isProducts = location.pathname === Paths.SEARCH_RESULTS_PRODUCTS;
  const isSolutions = location.pathname === Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS;
  const shouldFetch = !gates.tabularSearch && !!search && (isProducts || isSolutions);
  const otherProductTypes = isProducts ? ['SOLUTIONS_PARTNER_PROFILE'] : ['APP', 'AGENT'];
  const result = useAppContextQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      context: {
        timeout: CROSS_SEARCH_TIMEOUT_MS
      },
      skip: !shouldFetch,
      variables: {
        filter: buildProductTypeFilter(otherProductTypes),
        length: LISTINGS_PER_PAGE,
        offset: 0,
        search,
        language: getLang()
      }
    }
  });
  if (!shouldFetch) {
    return {
      count: undefined,
      isProducts,
      isSolutions
    };
  }
  return {
    count: (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.result.total,
    isProducts,
    isSolutions
  };
}